export enum ResponseTypes {
  Init = -1,
  LogIn = 1,
  LogOut = 2,
}
